// extracted by mini-css-extract-plugin
export default {"green":"green__wt61J","red":"red__my45Y"};